export const CHECK_ERROR = 'CHECK_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const SET_P11FORM_DATA = 'SET_P11FORM_DATA';
export const SET_P11STATUS = 'SET_P11STATUS';
export const ONCHANGE_FORM1 = 'ONCHANGE_FORM1';
export const ONCHANGE_FORM2 = 'ONCHANGE_FORM2';
export const ONCHANGE_FORM3 = 'ONCHANGE_FORM3';
export const ONCHANGE_FORM4 = 'ONCHANGE_FORM4';
export const ONCHANGE_FORM5 = 'ONCHANGE_FORM5';
export const ONCHANGE_FORM6 = 'ONCHANGE_FORM6';
export const ONCHANGE_FORM7 = 'ONCHANGE_FORM7';
export const ONCHANGE_FORM8 = 'ONCHANGE_FORM8';
export const SET_ROSTER_PROCESS_P11 = 'SET_ROSTER_PROCESS_P11';
export const SET_DISCLAIMER_AGREE = 'SET_DISCLAIMER_AGREE';
export const SET_DISCLAIMER_OPEN = 'SET_DISCLAIMER_OPEN';
